import { useRef } from "react";

const append = (base, text) => `${base}${base && !/\s$/.test(base) ? " " : ""}${text}`;

/**
 * Wires SpeechToTextButton to a plain text field so speech appears as it is spoken:
 * interim text is rendered live and rewritten as the model refines it, and every
 * finalised segment is appended permanently. Spread the result *after*
 * `speechToTextOptions` so these handlers win, and pass the caller's options in so
 * their own onTranscript/onStart still run.
 */
const useSpeechToTextField = (value, setValue, options = {}) => {
  // Text already committed to the field when the current dictation started, so a
  // refined interim can replace the previous one without eating the user's own text.
  const committedRef = useRef("");
  const valueRef = useRef(value);
  valueRef.current = value;

  return {
    onStart: () => {
      committedRef.current = valueRef.current || "";
      options.onStart?.();
    },
    onInterimTranscript: (interim) => {
      setValue(interim ? append(committedRef.current, interim) : committedRef.current);
    },
    onTranscript: (transcript) => {
      committedRef.current = append(committedRef.current, transcript);
      setValue(committedRef.current);
      options.onTranscript?.(transcript);
    },
  };
};

export default useSpeechToTextField;
